import { Badge, type BadgeTone } from '@/components/Badge/Badge';
import type { FindingSeverity } from '@/lib/api/types';

const TONES: Record<FindingSeverity, BadgeTone> = {
  error: 'critical',
  warning: 'warning',
  info: 'neutral',
};

export function SeverityBadge({ severity }: { severity: FindingSeverity }) {
  return <Badge tone={TONES[severity]}>{severity}</Badge>;
}
